import type {CustomerProfileOverviewContext} from "~/components/entityProfile/overview/types";
import {ProfileOverviewTabView} from "~/components/entityProfile/overview/profileOverviewTabView";
import type {CustomerProfileTabContext} from "~/components/entityProfile/profileTabRegistry";
import type {ProfileTabRenderProps} from "~/components/entityProfile/types";

export function ProfileOverviewTabContent({
    tabRenderProps,
    context,
}: {
    tabRenderProps: ProfileTabRenderProps;
    context: CustomerProfileTabContext;
}) {
    if (tabRenderProps.kind !== "customer") {
        return null;
    }

    return <ProfileOverviewTabView overview={context.overview} />;
}
